"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentsRegistryCalculatorSym = exports.FeaturesChunksExtractorSym = exports.SsrModelsBuilderSym = exports.ModulesLoaderSym = exports.SiteModelSym = exports.TemplateRendererSym = exports.HeadersCalculatorSym = exports.HeadModelCalculatorSym = exports.HeadProviderSym = exports.HeadContentSymbol = void 0;
exports.HeadContentSymbol = Symbol.for('HeadContentSymbol');
exports.HeadProviderSym = Symbol.for('HeadProviderSym');
exports.HeadModelCalculatorSym = Symbol('HeadModelCalculator');
exports.HeadersCalculatorSym = Symbol('HeadersCalculator');
exports.TemplateRendererSym = Symbol('TemplateRenderer');
exports.SiteModelSym = Symbol('SiteModel');
exports.ModulesLoaderSym = Symbol('ModulesLoader');
exports.SsrModelsBuilderSym = Symbol('SsrModelsBuilder');
exports.FeaturesChunksExtractorSym = Symbol('FeaturesChunksExtractor');
exports.ComponentsRegistryCalculatorSym = Symbol('ComponentsRegistryCalculatorSym');
//# sourceMappingURL=head.js.map